<template>
  <div>
    <div class="detail-info subdivide life">
      <div>
        <span class="info-key">体温：</span>
        <div>
          <span class="info-item">
            {{ patient.temperature }}
          </span>
          <span class="info-key unit">℃</span>
        </div>
      </div>
      <div>
        <span class="info-key">呼吸：</span>
        <div>
          <span class="info-item">{{ patient.breath }}</span>
          <span class="info-key unit">次/分</span>
        </div>
      </div>
      <div>
        <span class="info-key">血糖：</span>
        <div>
          <span class="info-item"> {{ patient.bloodSuger }} </span>
          <span class="info-key unit">mmol/l </span>
        </div>
      </div>
      <div>
        <span class="info-key">收缩压：</span>

        <div>
          <span class="info-item">{{ patient.systolicPressure }}</span>

          <span class="info-key unit">mmHg</span>
        </div>
      </div>
      <div>
        <span class="info-key">舒张压：</span>
        <div>
          <span class="info-item">{{ patient.diastolicPressure }}</span>
          <span class="info-key unit">mmHg</span>
        </div>
      </div>
    </div>
    <div class="detail-info subdivide">
      <div class="info-title specific">意识状态：</div>
      <el-radio
        v-model="patient.awareness"
        label="清醒"
        :disabled="'清醒' !== patient.awareness"
      >清醒
      </el-radio>
      <el-radio
        v-model="patient.awareness"
        label="嗜睡"
        :disabled="'嗜睡' !== patient.awareness"
      >嗜睡
      </el-radio>
      <el-radio
        v-model="patient.awareness"
        label="模糊"
        :disabled="'模糊' !== patient.awareness"
      >模糊
      </el-radio>
      <el-radio
        v-model="patient.awareness"
        label="浅昏迷"
        :disabled="'浅昏迷' !== patient.awareness"
      >浅昏迷
      </el-radio>
      <el-radio
        v-model="patient.awareness"
        label="深昏迷"
        :disabled="'深昏迷' !== patient.awareness"
      >深昏迷
      </el-radio>
      <el-radio
        v-model="patient.awareness"
        label="错乱"
        :disabled="'错乱' !== patient.awareness"
      >错乱
      </el-radio>
    </div>
    <div class="detail-info subdivide particular">
      <div class="info-title specific">瞳孔：</div>
      <el-radio
        v-model="patient.pupil"
        label="反射"
        :disabled="'反射' !== patient.pupil"
      >反射
      </el-radio>
      <el-radio
        v-model="patient.pupil"
        label="迟钝"
        :disabled="'迟钝' !== patient.pupil"
      >迟钝
      </el-radio>
      <el-radio
        v-model="patient.pupil"
        label="消失"
        :disabled="'消失' !== patient.pupil"
      >消失
      </el-radio>
    </div>
    <div class="detail-info">
      <span class="info-title">病情分级：</span>
      <four-level :level="patient.illness_level" :only-look="true"/>
    </div>
    <div class="detail-info">
      <div class="info-title">初诊：</div>
      <span class="info-item">{{ patient.fistCheck }}</span>
    </div>
    <div class="detail-info">
      <div class="info-title description">详细描述：</div>
      <span class="info-item">{{ patient.details }}</span>
    </div>
  </div>

</template>

<script>
import FourLevel from "@components/common/FourLevel";
import { mapState } from "vuex";

export default {
  name: "SituationLook",
  components: { FourLevel },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),

  },
};
</script>

<style scoped>

</style>
